import {
  ArticleFieldsFragment,
  CategoryFieldsFragment,
  LanguageId,
} from 'lib-knowledge-management-common/graphql';

type Titles =
  | CategoryFieldsFragment['titles']
  | ArticleFieldsFragment['titles'];

/**
 * The title in the language asked for, falling back to English and then to
 * whichever translation comes first — a category or article can be untranslated
 * for the language it is being shown in, and a blank name is worse than a name
 * in the wrong language.
 */
export function extractTitleFromTranslations(
  titles: Titles,
  languageId: LanguageId = LanguageId.En,
): string {
  return (
    titles.find((title) => title.languageId === languageId)?.title ||
    `${titles[0].title}`
  );
}
